// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"35deb00f","126":"b9ab3eed","351":"93e28863","654":"6e6a01b1","893":"38e1efc8","915":"a20bbc44"}[chunkId] + ".chunk.js";
};